import { Controller } from "@hotwired/stimulus"

// Toggles the visibility of the custom date range inputs based on the
// date preset selection. Listens for the form's bubbled `change` events
// and re-evaluates visibility from the current value of the hidden
// `date_preset` input within the form.
export default class extends Controller {
  static targets = ["customRange"]

  connect() {
    this.update()
  }

  update() {
    if (!this.hasCustomRangeTarget) return
    const datePresetInput = this.element.querySelector('input[name="date_preset"]')
    if (!datePresetInput) return
    const isCustom = datePresetInput.value === "custom"
    this.customRangeTarget.classList.toggle("hidden", !isCustom)
  }
}
